const ACCOUNTS_API = import.meta.env.VITE_B2C_PROXY_URL || 'https://svc.nonprod.klik-plus.com/v1/accounts';
const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8081';
const CLIENT_ID = import.meta.env.VITE_B2C_CLIENT_ID || '';
const REDIRECT_URI = import.meta.env.VITE_B2C_REDIRECT_URI || window.location.origin + '/auth/callback';

export const authConfig = {
  accountsApi: ACCOUNTS_API,
  apiBase: API_BASE,
  clientId: CLIENT_ID,
  redirectUri: REDIRECT_URI,
  scopes: 'openid profile email',
};

export function getAuthorizationUrl(): string {
  const state = crypto.randomUUID();
  sessionStorage.setItem('auth_state', state);

  const params = new URLSearchParams({
    client_id: authConfig.clientId,
    redirect_uri: authConfig.redirectUri,
    response_type: 'code',
    scope: authConfig.scopes,
    state,
  });
  return `${authConfig.accountsApi}/api/auth/authorize?${params}`;
}

export interface TokenResponse {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
  refreshToken: string;
  idToken: string;
}

export async function exchangeCodeForTokens(code: string): Promise<TokenResponse> {
  const res = await fetch(`${authConfig.apiBase}/api/v1/auth/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      grant_type: 'authorization_code',
      code,
      redirect_uri: authConfig.redirectUri,
      client_id: authConfig.clientId,
    }),
  });

  if (!res.ok) {
    throw new Error('Authentication failed. Please try again.');
  }

  return res.json();
}

export async function refreshAccessToken(token: string): Promise<TokenResponse> {
  const res = await fetch(`${authConfig.apiBase}/api/v1/auth/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      grant_type: 'refresh_token',
      code: token,
      redirect_uri: authConfig.redirectUri,
      client_id: authConfig.clientId,
    }),
  });

  if (!res.ok) {
    throw new Error('Session expired. Please log in again.');
  }

  return res.json();
}
